module.exports = __webpack_public_path__ + "img/bento.dda82107.png";